function getLoyaltyBenefitAvailability(benefit: App.LoyaltyBenefit): number {
  if (benefit.unlimited) return Infinity
  return benefit.remaining ?? 0
}

export default getLoyaltyBenefitAvailability
